import PATHS from '../constants';

function fetchBlogCategories() {
    const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
    };
    return fetch(PATHS.BLOG_CATEGORIES, {
        method: 'GET',
        dataType: 'json',
        headers,
    });
};

export default fetchBlogCategories;